import type { Job } from '@mairistem/composants';
import { request } from '@mairistem/tools';

const exportBiens = (identifiantExercice: number) =>
	request.get<unknown, Job>(
		`/api/finances/biens/export?identifiantExercice=${identifiantExercice}`,
	);

export default exportBiens;
